export const POPUP_OPTION = {
  DO_NOT_SHOW_AGAIN: '다시 보지 않기',
  DO_NOT_SHOW_AGAIN_FOR_THREE_DAYS: '3일 동안 보지 않기',
}
